export default __webpack_public_path__ + "static/media/News.4bcb4a96.svg";